import api from '../../api/$api'
import aspida from '@aspida/axios'
import { ChildCategory, ParentCategory } from '../../api/@types'

export const getParentCategories = async (): Promise<ParentCategory[]> => {
  const instance = api(aspida())

  try {
    const data = await instance.category.parent.$get()
    return data
  } catch (e) {
    throw new Error('error.category.getParentCategories')
  }
}

export const getChildCategories = async (
  parents: number[] | undefined,
): Promise<ChildCategory[]> => {
  const instance = api(aspida())

  try {
    const data = await instance.category.child.$get({ query: { parents } })
    return data
  } catch (e) {
    throw new Error('error.category.getChildCategories')
  }
}
